import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateTeam } from 'api/queries/workflows/teams';
import { useRouter } from 'next/router';
import * as toast from 'legacy/common/utils/toast';
import TeamEditor from './components/TeamEditor';

const AssociationAdminTeamsCreate = () => {
  const router = useRouter();
  const { associationId } = router.query as { associationId: string };
  const { t } = useTranslation(['associations']);
  const { mutate: createTeam, isLoading: isSaving } = useCreateTeam();

  const handleSaveTeam = (teamName: string, selectedMembers: any[]) => {
    createTeam(
      {
        associationId,
        team: {
          name: teamName,
          members: selectedMembers.map((member) => member.user.id)
        }
      },
      {
        onSuccess: () => {
          toast.success(t('settings.teams.teamSavedSuccessfully'));
          router.push(`/associations/${associationId}/settings/teams`);
        }
      }
    );
  };

  return (
    <TeamEditor
      onSave={handleSaveTeam}
      isSaving={isSaving}
      saveButtonText={t('settings.teams.saveTeam')}
    />
  );
};

export default AssociationAdminTeamsCreate;
